import { createStore } from "vuex";
import { config } from "vuex-module-decorators";

import AuthModule from "@/store/modules/AuthModule";
import BodyModule from "@/store/modules/BodyModule";
import BreadcrumbsModule from "@/store/modules/BreadcrumbsModule";
import ConfigModule from "@/store/modules/ConfigModule";

import DashboardModule from "@/store/modules/DashboardModule";
import UserModule from "@/store/modules/UserModule";
import RoleModule from "@/store/modules/RoleModule";
import MenuModule from "@/store/modules/MenuModule";
import LogModule from "@/store/modules/LogModule";
import CommonModule from "@/store/modules/CommonModule";
import SystemConfigModule from "./modules/SystemConfigModule";
//
import CounterLogModule from "./modules/QMS/CounterLogModule";
import CounterModule from "./modules/QMS/CounterModule";
import CountModule from "./modules/QMS/CountModule";
import EmployeeModule from "./modules/QMS/EmployeeModule";
import EmployeeStatusModule from "./modules/QMS/EmployeeStatusModule";
import EmployeeStatusLogModule from "./modules/QMS/EmployeeStatusLogModule";
import ServiceModule from "./modules/QMS/ServiceModule";
import ExchangeStatusModule from "./modules/QMS/ExchangeStatusModule";
import SpeakerModule from "./modules/QMS/SpeakerModule";
import SpeakerLogModule from "./modules/QMS/SpeakerLogModule";
import BoothModule from "./modules/QMS/BoothModule";
import RatingModule from "./modules/QMS/RatingModule";
import QueueNumberModule from "./modules/QMS/QueueNumberModule";
import RegulationNewsModule from "./modules/QMS/RegulationNewsModule";
import RegulationNewsTypeModule from "./modules/QMS/RegulationNewsTypeModule";
import SocialNewsModule from "./modules/QMS/SocialNewsModule";
import CiviLifeNewsModule from "./modules/QMS/CiviLifeNewsModule";
import CiviLifeNewsTypeModule from "./modules/QMS/CiviLifeNewsTypeModule";
import ProceduresModule from "./modules/QMS/ProceduresModule";
//
import BannersModule from "@/store/modules/MiniApp/BannersModule";
import FeedbacksModule from "@/store/modules/MiniApp/FeedbacksModule";
import HotlinesModule from "@/store/modules/MiniApp/HotlinesModule";
import NewsModule from "@/store/modules/MiniApp/NewsModule";
import CategoriesModule from "@/store/modules/MiniApp/CategoriesModule";
import CautionaryModule from "@/store/modules/MiniApp/CautionaryModule";
import ReportingModule from "@/store/modules/MiniApp/ReportingModule";
import QuestionsModule from "@/store/modules/MiniApp/QuestionsModule";
import AppointmentModule from "@/store/modules/MiniApp/AppointmentModule";
import DepartmentModule from "@/store/modules/MiniApp/DepartmentModule";
import LawQuestionsModule from "@/store/modules/MiniApp/LawQuestionsModule";
import LawExamsModule from "./modules/MiniApp/LawExamsModule";
import ZonesModule from "./modules/MiniApp/ZonesModule";
import HistoryQuestionsModule from "./modules/MiniApp/HistoryQuestionsModule";
import HistoryExamsModule from "./modules/MiniApp/HistoryExamsModule";
import TrainningModule from "./modules/MiniApp/TrainningModule";
import ChatHistoryModule from "./modules/MiniApp/ChatHistoryModule";
import LawTypeModule from "./modules/MiniApp/LawTypeModule";
import VideosModule from "./modules/QMS/VideosModule";
import ZaMapModule from "./modules/Za/MapModule";
import ZaAudioModule from "./modules/Za/AudioModule";



import ZaloModule from "./modules/ZaloModule";

import app from "@/store/modules/app";
import iframe from "@/store/modules/iFrame";

config.rawError = true;

const store = createStore({
  modules: {
    app,
    iframe,
    AuthModule,
    BodyModule,
    BreadcrumbsModule,
    ConfigModule,
    UserModule,
    RoleModule,
    MenuModule,
    CommonModule,
    LogModule,
    DashboardModule,
    SystemConfigModule,
    ////
    CounterLogModule,
    CounterModule,
    CountModule,
    EmployeeModule,
    EmployeeStatusModule,
    EmployeeStatusLogModule,
    ServiceModule,
    ExchangeStatusModule,
    SpeakerModule,
    SpeakerLogModule,
    BoothModule,
    RatingModule,
    QueueNumberModule,
    RegulationNewsModule,
    RegulationNewsTypeModule,
    SocialNewsModule,
    CiviLifeNewsModule,
    CiviLifeNewsTypeModule,
    ProceduresModule,
    ////
    BannersModule,
    FeedbacksModule,
    HotlinesModule,
    NewsModule,
    CategoriesModule,
    QuestionsModule,
    AppointmentModule,
    DepartmentModule,
    LawQuestionsModule,
    LawExamsModule,
    HistoryQuestionsModule,
    HistoryExamsModule,
    ZonesModule,
    TrainningModule,
    ChatHistoryModule,
    LawTypeModule,
    CautionaryModule,
    ReportingModule,
    VideosModule,
    ZaloModule,
    ZaMapModule,
    ZaAudioModule
  },
});

export default store;
